import I18n from 'I18n';
import Raven from 'raven-js';
import enviro from 'enviro';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { updateGoogleSearchConsoleAccount } from './googleSearchConsoleApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const GoogleSearchConsoleServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const handleAuthSucceeded = authedEmail => {
    void updateGoogleSearchConsoleAccount({
      email: authedEmail
    }).then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(authedEmail);
    }).catch(err => {
      if (!enviro.deployed()) {
        console.error(err);
      }
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: err,
        errorMessage: I18n.text('reconnect.errors.updateAccountFailed')
      });
      Raven.captureException(err, {
        extra: {
          appId: metadata === null || metadata === void 0 ? void 0 : metadata.appId,
          email: authedEmail,
          status: metadata === null || metadata === void 0 ? void 0 : metadata.status
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: url
  });
};